module.exports = __webpack_public_path__ + "static/img/news3.5a9d3a3a.png";